import { render } from "./ManageRequests.vue?vue&type=template&id=5cfc3cbc&scoped=true"
import script from "./ManageRequests.vue?vue&type=script&lang=js"
export * from "./ManageRequests.vue?vue&type=script&lang=js"

import "./ManageRequests.vue?vue&type=style&index=0&id=5cfc3cbc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfc3cbc"]])

export default __exports__